import React from 'react'
import { useIntl } from 'react-intl'

import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { SectionPricingQuotes } from '../pricing/SectionPricingQuotes'
import { SectionBookDemo } from './SectionBookDemo'

export default function BookDemoPage() {
  const intl = useIntl()
  const routes = useRoutes()
  const pageTitle = intl.formatMessage({
    id: 'bookdemo.title',
    defaultMessage: 'Book a demo | Slite',
  })
  const pageDescription = intl.formatMessage({
    id: 'bookdemo.description',
    defaultMessage:
      "Discover Slite's advanced documentation capabilities. Book a demo and learn how to streamline collaboration and knowledge sharing with your team and users.",
  })
  const pageImage =
    'https://cdn.sanity.io/images/dnsgqii5/production/14f802c185483f1cd39b27897cbd571ec3bb88a3-2400x1254.jpg'
  const pageUrl = routes.bookDemo()

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      ogImage={pageImage}
      ogTitle={pageTitle}
      ogDescription={pageDescription}
      canonicalUrl={pageUrl}
      background="moon-dust"
    >
      <SectionBookDemo />
      <SectionPricingQuotes />
    </SlitePage>
  )
}
